
import React, {useEffect, useState} from "react";
import API, {ROUTES} from "../../../commons/api/api";
import FaqPageComponent from "./../components/index"

const FaqPageContainer  = () => {

    const [faqData, setFaqData] = useState([])
    const [loadMore, setloadMore] = useState(false)
    const [loading, setLoading] = useState(true)
    const [faqCategories, setFaqCategories] = useState([])


    const fetchData = async (param = '?page=1&limit=20') =>{
        try {
            const {data: response} = await API.get(ROUTES.API_FAQ+param);
            setFaqData(response?.data);
            setLoading(false)
            if(response?.data?.current_page == response?.data?.last_page) {
                setloadMore(false)
            }else {
                setloadMore(true)
            }
        } catch (error) {
            console.error(error.message);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    const loadMoreData = () => {
        setloadMore(false)
    }

    return <FaqPageComponent faqData={faqData} FaqCategories={faqCategories} fetchData={fetchData} loading={loading} />;
};

export default FaqPageContainer ;